if (!customElements.get("sht-language-switcher")) {
  class LanguageSwitcher extends SHTCustomComponent {
    constructor() {
      super();
      this.subElms = {
        language_code_field: this.$(".js-language-switcher-language-code-field"),
        language_btn:        this.$(".js-language-switcher-btn"),
        language_list:       this.$(".js-language-switcher-language-list"),
        language_link_items: this.$$(".js-language-switcher-language-item-link"),
        language_form:       this.$(".js-language-switcher-form")
      };
      this.subElms.language_btn.addEventListener("click", this.toggleLanguageSwitcher.bind(this));
      this.subElms.language_btn.addEventListener("focusout", e => {
        this.contains(e.relatedTarget) || this.hideLanguageListPanel();
      });
      this.subElms.language_link_items.forEach(a => {
        a.addEventListener("click", this.onLinkItemClickHandler.bind(this));
      });
      this.addEventListener("keyup", this.onKeyUpLanguageSwitcherHandler.bind(this));
    }
    toggleLanguageSwitcher() {
      this.subElms.language_btn.focus(); this.toggleLanguageList();
    }
    toggleLanguageList() {
      this.subElms.language_btn.focus();
      if (this.subElms.language_list.classList.contains("is-open")) {
        this.subElms.language_list.classList.remove("is-open");
        this.subElms.language_btn.setAttribute("aria-expanded","false");
      } else {
        this.subElms.language_list.classList.add("is-open");
        this.subElms.language_btn.setAttribute("aria-expanded","true");
      }
    }
    hideLanguageListPanel() {
      this.subElms.language_btn.setAttribute("aria-expanded","false");
      this.subElms.language_list.classList.remove("is-open");
    }
    onKeyUpLanguageSwitcherHandler(e) {
      if (e && e.code && e.code.toUpperCase() === "ESCAPE") {
        this.subElms.language_btn.focus(); this.hideLanguageListPanel();
      }
    }
    onLinkItemClickHandler(e) {
      e.preventDefault();
      this.subElms.language_code_field.value = e.currentTarget.dataset.value;
      const rt = this.subElms.language_form.querySelector('[name="return_to"]');
      if (rt) rt.value = window.location.pathname;
      this.subElms.language_form.submit();
    }
  }
  customElements.define("sht-language-switcher", LanguageSwitcher);
}
